import { Stack, Text } from '@mantine/core';

import RiskIndicators from '../../riskindicators/RiskIndicators';

import { createHelper } from '../../issue/utils/helper';
import { formatIsoDate } from '@/utils/date';
import { getEntries } from '@/utils';

import type { Module } from '../../issue/types/modulesv2';
import type { SignalCollectors } from '../types';
import type { NormalizedSignal } from '@/services/unifiedapi';

const helper = createHelper<NormalizedSignal>();

export const signalDrawer = (type: SignalCollectors): Array<Module<NormalizedSignal>> => [
  {
    submodules: [
      helper.accessor((data) => data.title, {
        element: ({ getValue }) => (
          <Stack gap={10} align="center" justify="center">
            <Text fw="bold" ta="center">
              {getValue()}
            </Text>
            <Text size="sm">Signal</Text>
          </Stack>
        ),
      }),
    ],
  },
  {
    submodules: [
      helper.accessor(
        (data) => ({
          locations: getEntries(data.catalog.locations).map(([id, name]) => ({ id, name })),
          technologies: getEntries(data.catalog.technologies).map(([id, name]) => ({ id, name })),
          industry_sectors: getEntries(data.catalog.industry_sectors).map(([id, name]) => ({
            id,
            name,
          })),
        }),
        {
          title: 'Your Relevancy',
          element: RiskIndicators,
          scroll: false,
        }
      ),
    ],
  },
  {
    submodules: [
      helper.accessor((data) => data.text, {
        title: 'Translated Content',
      }),
    ],
  },
  {
    title: 'Signal Information',
    submodules: [
      helper.accessor((data) => data.catalog.source, {
        title: 'Source',
      }),
      helper.accessor((data) => data.link, {
        title: 'URL',
      }),
      helper.accessor((data) => data.ingested_at, {
        title: 'Ingested At',
        element: ({ getValue }) => formatIsoDate(getValue()),
      }),
      helper.accessor((data) => data.published_at, {
        title: 'Published At',
        element: ({ getValue }) => formatIsoDate(getValue()),
      }),
      helper.accessor((data) => data.updated_at, {
        title: 'Updated At',
        element: ({ getValue }) => formatIsoDate(getValue()),
      }),
    ],
  },
];
